var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#5570F1",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_342_13188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6747 21.2417C25.1445 22.4955 24.3153 23.6002 23.2596 24.4595C22.2038 25.3187 20.9537 25.9063 19.6184 26.1707C18.2831 26.4352 16.9034 26.3685 15.5998 25.9766C14.2962 25.5846 13.1085 24.8793 12.1405 23.9223C11.1725 22.9653 10.4537 21.7857 10.0469 20.4867C9.64006 19.1877 9.55765 17.8088 9.80685 16.4706C10.056 15.1324 10.6293 13.8756 11.4764 12.8101C12.3235 11.7446 13.4188 10.9028 14.6664 10.3584",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 17.9998C26.3333 16.9055 26.1178 15.8219 25.699 14.8108C25.2802 13.7998 24.6664 12.8811 23.8926 12.1073C23.1187 11.3335 22.2001 10.7196 21.189 10.3008C20.178 9.88205 19.0943 9.6665 18 9.6665V17.9998H26.3333Z",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342_13188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrder);
export default __webpack_public_path__ + "static/media/totalOrder.b78f286350161667bbb2bc4363f5e749.svg";
export { ForwardRef as ReactComponent };